module.exports = __webpack_public_path__ + "static/media/greeves-common.4fd83483.png";